var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"web@9.25.1"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

 
import * as Sentry from '@sentry/nextjs';
import { CaptureConsole } from '@sentry/integrations';
import chalk from 'chalk';
import { publicRuntimeConfig } from './src/utils/publicRuntimeConfig';
import { applySampling } from './src/utils/sentry/configOverrides';

Sentry.init({
  dsn: publicRuntimeConfig.sentry.dsn,
  tracesSampleRate: false,
  integrations: [
    new CaptureConsole({
      levels: ['error'],
    }),
  ],
  beforeSend: (event) => {
    const errorMessage = event?.exception?.values[0]?.value;

    if (process.env.NODE_ENV === 'development') {
      console.info(`${chalk.red('Sentry')} - ${errorMessage}`);
      console.info({ event });
      return null;
    }

    if (errorMessage === '[object Event]') return null;

    return applySampling(event);
  },
});

console.info(`Sentry initialized with environment: ${publicRuntimeConfig.sentry.environment}`);
